import { Divider, Skeleton } from "../../../../../components/UiComponents/Ui";


const SupplierSetupDetailsLoader = () => {
  return (
    <div className="overflow-y-auto">
      <div className="flex justify-between items-start gap-6">
        <div className="space-y-4 w-[50%]">
          <div className="px-6 py-3 space-y-3 shadow-cardShadow bg-white rounded-xl">
            <header className="flex justify-between items-center">
              <div className="space-y-1">
                <Skeleton width={130} height={14} />
                <Skeleton width={190} height={10} />
              </div>
              <Skeleton width={60} height={28} />
            </header>
            <Divider />
            <div className="space-y-[8px]">
              <div>
                {[80, 70, 60, 65, 100].map((w, i) => (
                  <div
                    key={i}
                    className="flex justify-between items-center py-[6px]"
                  >
                    <Skeleton width={w} height={11} />
                    <Skeleton width={w + 40} height={11} />
                  </div>
                ))}
              </div>
              <Divider />
              <div>
                {[80, 110].map((w, i) => (
                  <div
                    key={i}
                    className="flex justify-between items-center py-[6px]"
                  >
                    <Skeleton width={w} height={11} />
                    <Skeleton width={w + 20} height={11} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="px-6 py-3 space-y-3 shadow-cardShadow bg-white rounded-xl">
            <header className="flex justify-between items-center">
              <div className="space-y-1">
                <Skeleton width={140} height={14} />
                <Skeleton width={210} height={10} />
              </div>
              <Skeleton width={32} height={28} />
            </header>
            <Divider />
            <div className="space-y-[8px]">
              {[70, 60, 55].map((w, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center py-[6px]"
                >
                  <Skeleton width={w} height={11} />
                  <Skeleton width={36} height={20} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="space-y-4 w-[50%]">
          <div className="px-6 py-3 space-y-3 shadow-cardShadow bg-white rounded-xl">
            <header className="flex justify-between items-center">
              <div className="space-y-1">
                <Skeleton width={140} height={14} />
                <Skeleton width={190} height={10} />
              </div>
              <Skeleton width={60} height={28} />
            </header>
            <Divider />
            <div className="space-y-[8px]">
              {[90, 70].map((w, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center py-[6px]"
                >
                  <Skeleton width={w} height={11} />
                  <Skeleton width={w + 20} height={11} />
                </div>
              ))}
            </div>
          </div>

          <div className="px-6 py-3 space-y-3 shadow-cardShadow bg-white rounded-xl">
            <header className="flex justify-between items-center">
              <div className="space-y-1">
                <Skeleton width={160} height={14} />
                <Skeleton width={190} height={10} />
              </div>
              <Skeleton width={60} height={28} />
            </header>
            <Divider />
            <div className="flex justify-between items-center py-[6px]">
              <Skeleton width={70} height={11} />
              <Skeleton width={100} height={11} />
            </div>
          </div>

          <div className="px-6 py-3 space-y-3 shadow-cardShadow bg-white rounded-xl">
            <header className="flex justify-between items-center">
              <div className="space-y-1">
                <Skeleton width={80} height={14} />
                <Skeleton width={210} height={10} />
              </div>
              <Skeleton width={32} height={28} />
            </header>
            <Divider />
            <div className="space-y-[8px]">
              {[160, 220, 130, 180, 200, 120].map((w, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center py-[6px]"
                >
                  <Skeleton width={w} height={11} />
                  <Skeleton width={36} height={20} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierSetupDetailsLoader;
